import { render, staticRenderFns } from "./AdminSpecialBets.vue?vue&type=template&id=5b56ac43&"
import script from "./AdminSpecialBets.vue?vue&type=script&lang=js&"
export * from "./AdminSpecialBets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports